export default {
  header: {
    main: "Confirm order",
    order_summary: "Order Summary",
  },
  labels: {
    total: "Total",
  },
  steps: {
    payment_note: {
      title: "Payment notice: No cash",
      subtext:
        "When ordering online, we kindly ask you to pay online. Payment can be made at any time during or after the meal. 😊 *Cash payment only possible if you order at the counter.",
      button: {
        got_it: "Got it 👍",
      },
    },
    phone_number: {
      title: "Phone number",
      subtext:
        "We need your phone number to send you order updates and verify you are a real person.",
    },
    personal_information: {
      title: "Who is this order for? 😊",
    },
  },
  buttons: {
    add_products: "+ Add products",
    place_order: "Place order now",
  },
  empty_order_basket: {
    title: "Let's go",
    description: "Add items to get started",
  },
  loading_overlay: "Hold on… we’re sending your order to the kitchen",
};
